import BlLinkAv from './BlLinkAv.vue'

BlLinkAv.install = function(Vue) {
  Vue.component(BlLinkAv.name, BlLinkAv)
}

export default BlLinkAv
